/* shop/components/OrderPersonal.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	select_option,
	set_style,
	space,
	text
} from "svelte/internal";

import orderStore from "./../orderStore";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[12] = list[i];
	return child_ctx;
}

// (96:8) {#each countries as country}
function create_each_block(ctx) {
	let option;
	let t_value = /*country*/ ctx[12].name + "";
	let t;
	let option_value_value;

	return {
		c() {
			option = element("option");
			t = text(t_value);
			option.__value = option_value_value = /*country*/ ctx[12].code;
			option.value = option.__value;
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

function create_fragment(ctx) {
	let p0;
	let label0;
	let t1;
	let input0;
	let input0_value_value;
	let t2;
	let p1;
	let label1;
	let t4;
	let input1;
	let input1_value_value;
	let t5;
	let p2;
	let label2;
	let t7;
	let input2;
	let input2_value_value;
	let t8;
	let p3;
	let label3;
	let t10;
	let input3;
	let input3_value_value;
	let t11;
	let p4;
	let label4;
	let t13;
	let input4;
	let input4_value_value;
	let t14;
	let p5;
	let label5;
	let t16;
	let input5;
	let input5_value_value;
	let t17;
	let p6;
	let label6;
	let t19;
	let select;
	let option;
	let select_value_value;
	let t23;
	let p7;
	let label7;
	let t25;
	let textarea;
	let textarea_value_value;
	let mounted;
	let dispose;
	let each_value = /*countries*/ ctx[2];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			p0 = element("p");
			label0 = element("label");
			label0.textContent = `${gettext("Jméno a příjmení")}`;
			t1 = space();
			input0 = element("input");
			t2 = space();
			p1 = element("p");
			label1 = element("label");
			label1.textContent = `${gettext("Email")}`;
			t4 = space();
			input1 = element("input");
			t5 = space();
			p2 = element("p");
			label2 = element("label");
			label2.textContent = `${gettext("Telefon")}`;
			t7 = space();
			input2 = element("input");
			t8 = space();
			p3 = element("p");
			label3 = element("label");
			label3.textContent = `${gettext("Ulice")}`;
			t10 = space();
			input3 = element("input");
			t11 = space();
			p4 = element("p");
			label4 = element("label");
			label4.textContent = `${gettext("Město")}`;
			t13 = space();
			input4 = element("input");
			t14 = space();
			p5 = element("p");
			label5 = element("label");
			label5.textContent = `${gettext("PSČ")}`;
			t16 = space();
			input5 = element("input");
			t17 = space();
			p6 = element("p");
			label6 = element("label");
			label6.textContent = `${gettext("Stát")}`;
			t19 = space();
			select = element("select");
			option = element("option");
			option.textContent = `-- ${gettext("Vyberte stát")} --`;

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t23 = space();
			p7 = element("p");
			label7 = element("label");
			label7.textContent = `${gettext("Poznámka")}`;
			t25 = space();
			textarea = element("textarea");
			attr(label0, "for", "name_and_surname");
			attr(input0, "type", "text");
			input0.required = true;
			attr(input0, "id", "name_and_surname");

			input0.value = input0_value_value = /*$orderStore*/ ctx[0].name_and_surname
			? /*$orderStore*/ ctx[0].name_and_surname
			: "";

			attr(label1, "for", "email");
			attr(input1, "type", "email");
			input1.required = true;
			attr(input1, "id", "email");

			input1.value = input1_value_value = /*$orderStore*/ ctx[0].email
			? /*$orderStore*/ ctx[0].email
			: "";

			attr(label2, "for", "phone");
			attr(input2, "type", "text");
			input2.required = true;
			attr(input2, "id", "phone");

			input2.value = input2_value_value = /*$orderStore*/ ctx[0].phone
			? /*$orderStore*/ ctx[0].phone
			: "";

			attr(label3, "for", "address_street");
			attr(input3, "type", "text");
			input3.required = true;
			attr(input3, "id", "address_street");

			input3.value = input3_value_value = /*$orderStore*/ ctx[0].address_street
			? /*$orderStore*/ ctx[0].address_street
			: "";

			attr(label4, "for", "address_city");
			attr(input4, "type", "text");
			input4.required = true;
			attr(input4, "id", "address_city");

			input4.value = input4_value_value = /*$orderStore*/ ctx[0].address_city
			? /*$orderStore*/ ctx[0].address_city
			: "";

			attr(label5, "for", "address_zip");
			attr(input5, "type", "text");
			input5.required = true;
			attr(input5, "id", "address_zip");

			input5.value = input5_value_value = /*$orderStore*/ ctx[0].address_zip
			? /*$orderStore*/ ctx[0].address_zip
			: "";

			attr(label6, "for", "address_country");
			option.__value = "";
			option.value = option.__value;
			select.required = true;
			attr(select, "id", "address_country");
			set_style(select, "border", "1px solid #ccc");
			set_style(select, "padding", "6px");
			set_style(select, "border-radius", "25px");
			attr(label7, "for", "order_description");
			attr(textarea, "id", "order_description");

			textarea.value = textarea_value_value = /*$orderStore*/ ctx[0].order_description
			? /*$orderStore*/ ctx[0].order_description
			: '';
		},
		m(target, anchor) {
			insert(target, p0, anchor);
			append(p0, label0);
			append(p0, t1);
			append(p0, input0);
			insert(target, t2, anchor);
			insert(target, p1, anchor);
			append(p1, label1);
			append(p1, t4);
			append(p1, input1);
			insert(target, t5, anchor);
			insert(target, p2, anchor);
			append(p2, label2);
			append(p2, t7);
			append(p2, input2);
			insert(target, t8, anchor);
			insert(target, p3, anchor);
			append(p3, label3);
			append(p3, t10);
			append(p3, input3);
			insert(target, t11, anchor);
			insert(target, p4, anchor);
			append(p4, label4);
			append(p4, t13);
			append(p4, input4);
			insert(target, t14, anchor);
			insert(target, p5, anchor);
			append(p5, label5);
			append(p5, t16);
			append(p5, input5);
			insert(target, t17, anchor);
			insert(target, p6, anchor);
			append(p6, label6);
			append(p6, t19);
			append(p6, select);
			append(select, option);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(select, null);
				}
			}

			select_option(select, /*$orderStore*/ ctx[0].address_country
			? /*$orderStore*/ ctx[0].address_country
			: "");

			insert(target, t23, anchor);
			insert(target, p7, anchor);
			append(p7, label7);
			append(p7, t25);
			append(p7, textarea);

			if (!mounted) {
				dispose = [
					listen(input0, "blur", /*blur_handler*/ ctx[3]),
					listen(input1, "blur", /*blur_handler_1*/ ctx[4]),
					listen(input2, "blur", /*blur_handler_2*/ ctx[5]),
					listen(input3, "blur", /*blur_handler_3*/ ctx[6]),
					listen(input4, "blur", /*blur_handler_4*/ ctx[7]),
					listen(input5, "blur", /*blur_handler_5*/ ctx[8]),
					listen(select, "input", /*input_handler*/ ctx[9]),
					listen(textarea, "blur", /*blur_handler_6*/ ctx[10])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*$orderStore, countries*/ 5 && input0_value_value !== (input0_value_value = /*$orderStore*/ ctx[0].name_and_surname
			? /*$orderStore*/ ctx[0].name_and_surname
			: "") && input0.value !== input0_value_value) {
				input0.value = input0_value_value;
			}

			if (dirty & /*$orderStore, countries*/ 5 && input1_value_value !== (input1_value_value = /*$orderStore*/ ctx[0].email
			? /*$orderStore*/ ctx[0].email
			: "") && input1.value !== input1_value_value) {
				input1.value = input1_value_value;
			}

			if (dirty & /*$orderStore, countries*/ 5 && input2_value_value !== (input2_value_value = /*$orderStore*/ ctx[0].phone
			? /*$orderStore*/ ctx[0].phone
			: "") && input2.value !== input2_value_value) {
				input2.value = input2_value_value;
			}

			if (dirty & /*$orderStore, countries*/ 5 && input3_value_value !== (input3_value_value = /*$orderStore*/ ctx[0].address_street
			? /*$orderStore*/ ctx[0].address_street
			: "") && input3.value !== input3_value_value) {
				input3.value = input3_value_value;
			}

			if (dirty & /*$orderStore, countries*/ 5 && input4_value_value !== (input4_value_value = /*$orderStore*/ ctx[0].address_city
			? /*$orderStore*/ ctx[0].address_city
			: "") && input4.value !== input4_value_value) {
				input4.value = input4_value_value;
			}

			if (dirty & /*$orderStore, countries*/ 5 && input5_value_value !== (input5_value_value = /*$orderStore*/ ctx[0].address_zip
			? /*$orderStore*/ ctx[0].address_zip
			: "") && input5.value !== input5_value_value) {
				input5.value = input5_value_value;
			}

			if (dirty & /*countries*/ 4) {
				each_value = /*countries*/ ctx[2];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(select, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*$orderStore, countries*/ 5 && select_value_value !== (select_value_value = /*$orderStore*/ ctx[0].address_country
			? /*$orderStore*/ ctx[0].address_country
			: "")) {
				select_option(select, /*$orderStore*/ ctx[0].address_country
				? /*$orderStore*/ ctx[0].address_country
				: "");
			}

			if (dirty & /*$orderStore, countries*/ 5 && textarea_value_value !== (textarea_value_value = /*$orderStore*/ ctx[0].order_description
			? /*$orderStore*/ ctx[0].order_description
			: '')) {
				textarea.value = textarea_value_value;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(p0);
			if (detaching) detach(t2);
			if (detaching) detach(p1);
			if (detaching) detach(t5);
			if (detaching) detach(p2);
			if (detaching) detach(t8);
			if (detaching) detach(p3);
			if (detaching) detach(t11);
			if (detaching) detach(p4);
			if (detaching) detach(t14);
			if (detaching) detach(p5);
			if (detaching) detach(t17);
			if (detaching) detach(p6);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t23);
			if (detaching) detach(p7);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $orderStore;
	component_subscribe($$self, orderStore, $$value => $$invalidate(0, $orderStore = $$value));

	const setValue = (name, value, inputElm) => {
		const error = orderStore.setProp(name, value);

		if (inputElm.checkValidity() && !error) {
			inputElm.classList.remove('invalid');
		} else {
			inputElm.classList.add('invalid');
		}
	};

	const countriesElm = document.getElementById("svelteCountries");
	const countries = JSON.parse(countriesElm.dataset.svelteCountries);
	const blur_handler = e => setValue('name_and_surname', e.target.value, e.target);
	const blur_handler_1 = e => setValue('email', e.target.value, e.target);
	const blur_handler_2 = e => setValue('phone', e.target.value, e.target);
	const blur_handler_3 = e => setValue('address_street', e.target.value, e.target);
	const blur_handler_4 = e => setValue('address_city', e.target.value, e.target);
	const blur_handler_5 = e => setValue('address_zip', e.target.value, e.target);
	const input_handler = e => setValue('address_country', e.target.value, e.target);
	const blur_handler_6 = e => setValue('order_description', e.target.value, e.target);

	return [
		$orderStore,
		setValue,
		countries,
		blur_handler,
		blur_handler_1,
		blur_handler_2,
		blur_handler_3,
		blur_handler_4,
		blur_handler_5,
		input_handler,
		blur_handler_6
	];
}

class OrderPersonal extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default OrderPersonal;